import React from "react";
import logo2 from "../../assets/logo-black.svg";
import { useNavigate } from "react-router-dom";
import home from "../../assets/home.svg";
import wallet from "../../assets/wallet.svg";
import trade from "../../assets/trade.svg";
import transaction from "../../assets/transaction.svg";
import logout from "../../assets/logout.svg";
import contact from "../../assets/contact.svg";
import drag from "../../assets/drag.svg";
import { useLocation } from "react-router-dom";

function SidebarNew() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    {
      name: "Home",
      icon: home,
      path: "/dashboard",
    },
    {
      name: "Wallet",
      icon: wallet,
      path: "/wallet",
    },
    {
      name: "Trade assets",
      icon: trade,
      path: "/trading",
    },
    {
      name: "Transaction",
      icon: transaction,
      path: "/transactionhistory",
    },
    {
      name: "Contact us",
      icon: contact,
      path: "/contact",
    },
    {
      name: "Log out",
      icon: logout,
      path: "/logout",
    },
  ];

  return (
    <div className="hidden flex-col md:w-[300px] w-[237px] md:flex  pl-[53px] pt-[53px]   ">
      <button
        onClick={() => {
          navigate("/");
        }}
      >
        <img
          src={logo2}
          alt=""
          className="  w-[71px] md:w-[128px] h-[28px] md:h-[51px] md:mb-[85px] "
        />
      </button>
      <button className="mb-[78px] md:mb-[97px] self-end md:hidden">
        <img src={drag} alt="" className="" />
      </button>
      <nav className=" flex flex-col gap-[10px] md:gap-[15px] h-screen ">
        {navItems.map((item, index) => (
          <div
            key={index}
            className={`flex items-center hover:border-l-[#FBC108] hover:border-l-[11px]  focus:border-l-[11px] focus:border-l-[#FBC108] pl-[18px] hover:bg-[#ffffff70] py-[13px] md:w-[230px] cursor-pointer ${
              location.pathname === item.path
                ? "bg-gradient-to-r from-[#FBC108]/20 to-white border-l-[11px] border-l-[#FBC108]"
                : ""
            }`}
            onClick={() => navigate(item.path)}
          >
            <img src={item.icon} alt="" className="" />
            <h6 className="md:text-xl text-xs">{item.name}</h6>
          </div>
        ))}
      </nav>
    </div>
  );
}

export default SidebarNew;
